export const isDev = () => {
  if (typeof window === "undefined" || !window.location || !window.location.origin) {
    return false;
  }

  return (
    window.location.origin.includes(".dev.pga.com") ||
    window.location.origin.includes(".dev.pgahq.com") ||
    window.location.origin.includes("localhost")
  );
};

const getTld = () => (isDev() ? "my.dev.pga.com" : "my.pga.com");

const buildMyPgaUrl = (path: string, slug: string) => `https://${getTld()}/${path}/${slug}`;

const buildRegistrationOverrideUrl = (slug: string, eventId: string) => {
  const baseUrl = buildMyPgaUrl("member/events", slug);
  const encodedEventId = btoa(eventId);
  return `${baseUrl}?special_reg=${encodedEventId}`;
};

export const buildMemberPaymentUrl = ({
  id,
  type,
  payable
}: {
  id: string;
  type?: string | null;
  payable: boolean;
}): string | null => {
  if (!payable) {
    return null;
  }

  if (type === "education") {
    return `https://${getTld()}/member/education/purchase?orderId=${id}`;
  }

  if (type === "dues") {
    return `https://${getTld()}/member/dues`;
  }

  return `https://${getTld()}/member/account/invoices?slug=invoices`;
};

export { getTld, buildMyPgaUrl, buildRegistrationOverrideUrl };

export const openBrowser = (url: string) => {
  window.open(url);
};

export const showDevBanner = import.meta.env.MODE === "dev";

const _isMissingProtocol = (url: string) => !url.startsWith("http://") && !url.startsWith("https://");

export const ensureProtocol = (url: string, preferHttps: boolean = true) => {
  if (_isMissingProtocol(url)) {
    return preferHttps ? `https://${url}` : `http://${url}`;
  }
  return url;
};
